<template>
  <div>
    <ei-header :header2-show="true" :header2-lit="true"></ei-header>
    <div class="top-margin"></div>
    <div class="hengfu"></div>
    <ul class="video-list">
      <li class="video-item"></li>
      <li class="video-item"></li>
      <li class="video-item"></li>
      <li class="video-item"></li>
      <li class="video-item"></li>
      <li class="video-item"></li>
      <li class="video-item"></li>
      <li class="video-item"></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Video',
  data () {
    return {
      videoList:[
          
      ]
    }
  }
}
</script>

<style scoped lang="scss">
@import "../eiuov-ui/css/ei-common";
@import "../eiuov-ui/css/ei-font.css";

.font-test {
  font-family: XiaXingKai;
  font-size: 40px;
}

.video-list {
  display: flex;
  width: 1440 + 90px;
  margin-left: auto;
  margin-right: auto;
  justify-content: space-between;
  flex-wrap: wrap;

  .video-item {
    margin-top: 30px;
    width: 360px;
    height: 270px;
    background-color: #7C1A21;
    cursor: pointer;
  }
}

</style>
